import {
  keepPreviousData,
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { APIProvider as GoogleMapProvider } from "@vis.gl/react-google-maps";
import { ThemeProvider } from "next-themes";
import * as React from "react";
import { I18nextProvider } from "react-i18next";
import { TooltipProvider } from "~/components/tooltip";
import i18n from "~/lib/i18n";
// import { CookieConsentProvider } from "../cookie-consent";
import { errorStatus } from "~/lib/error";
import { ToastsProvider } from "../toasts/toasts";
import { AbilityProvider } from "./ability";
import { DialogProvider } from "./dialog";
import { FeaturesProvider } from "./features";
import { resetSession, SessionProvider } from "./session";
import { TestModeProvider } from "./test-mode";

// TODO: move into environment variables file
export const googleApiKey = "AIzaSyBC8F_brzc26g8UEclb6kGQHbJidAiNCPc";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
      staleTime: 1000 * 60 * 5, // make all data cache for 5 mins
      retry: false, // prevent auto-retry on fail
      retryOnMount: false, // prevent retry on fail and re-mount (e.g. map in observer)
    },
  },
  queryCache: new QueryCache({
    onError: (error: any) => {
      if (errorStatus(error) === 401) handleUnauthorizedApiRequest();
    },
  }),
  mutationCache: new MutationCache({
    onError: (error: any) => {
      if (errorStatus(error) === 401) handleUnauthorizedApiRequest();
    },
  }),
});

export const handleUnauthorizedApiRequest = () => {
  (async () => {
    queryClient.cancelQueries();
    try {
      await resetSession();
    } catch {
      window.location.href = "/";
    }
  })();
};

export const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <SessionProvider
      refetchOnRouteChange
      refetchOnWindowFocus
      refetchInterval={60}
    >
      <AbilityProvider>
        <ThemeProvider enableSystem={false} attribute="class">
          <I18nextProvider i18n={i18n}>
            <FeaturesProvider>
              {/* <CookieConsentProvider> */}
              <TestModeProvider>
                <QueryClientProvider client={queryClient}>
                  <GoogleMapProvider apiKey={googleApiKey}>
                    <ToastsProvider>
                      <TooltipProvider>
                        <DialogProvider>
                          <>{children}</>
                        </DialogProvider>
                      </TooltipProvider>
                    </ToastsProvider>
                  </GoogleMapProvider>
                  {/* <ReactQueryDevtools initialIsOpen={false} /> */}
                </QueryClientProvider>
              </TestModeProvider>
              {/* </CookieConsentProvider> */}
            </FeaturesProvider>
          </I18nextProvider>
        </ThemeProvider>
      </AbilityProvider>
    </SessionProvider>
  );
};
